import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      fontSize={size}
      style={style}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8ZM1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8Z"
      />
      <path d="M12 7.5C12.2761 7.5 12.5 7.72386 12.5 8C12.5 8.24546 12.3231 8.44961 12.0899 8.49194L12 8.5H4C3.72386 8.5 3.5 8.27614 3.5 8C3.5 7.75454 3.67688 7.55039 3.91012 7.50806L4 7.5H12Z" />
      <path d="M8.5 12C8.5 12.2761 8.27614 12.5 8 12.5C7.75454 12.5 7.55039 12.3231 7.50806 12.0899L7.5 12V4C7.5 3.72386 7.72386 3.5 8 3.5C8.24546 3.5 8.44961 3.67688 8.49194 3.91012L8.5 4V12Z" />
    </svg>
  );
}
